export interface Template {
  name: string;
  description: string;
  dependencies: Record<string, string>;
  devDependencies: Record<string, string>;
  files: string[];
}

export interface TemplateRegistry {
  [key: string]: Template;
}

export async function getTemplateRegistry(): Promise<TemplateRegistry> {
  return {
    'react-vanilla': {
      name: 'React + Vanilla CSS',
      description: 'Clean React components with vanilla CSS styling',
      dependencies: {
        '@feedinbox/sdk': '^1.0.0'
      },
      devDependencies: {
        '@types/react': '^19.0.0',
        '@types/react-dom': '^19.0.0'
      },
      files: [
        'FeedbackWidget.tsx',
        'NewsletterWidget.tsx', 
        'ContactWidget.tsx',
        'index.ts',
        'styles/index.css',
        'styles/feedback-widget.css',
        'styles/newsletter-widget.css',
        'styles/contact-widget.css'
      ]
    },
    'react-tailwind': {
      name: 'React + Tailwind CSS',
      description: 'React components styled with Tailwind CSS utilities',
      dependencies: {
        '@feedinbox/sdk': '^1.0.0'
      },
      devDependencies: {
        '@types/react': '^19.0.0',
        '@types/react-dom': '^19.0.0',
        'tailwindcss': '^3.4.0'
      },
      files: [
        'FeedbackWidget.tsx',
        'NewsletterWidget.tsx',
        'ContactWidget.tsx', 
        'index.ts'
      ]
    },
    'react-shadcn': {
      name: 'React + shadcn/ui',
      description: 'React components using shadcn/ui component library',
      dependencies: {
        '@feedinbox/sdk': '^1.0.0'
      },
      devDependencies: {
        '@types/react': '^19.0.0',
        '@types/react-dom': '^19.0.0'
      },
      files: [
        'FeedbackWidget.tsx',
        'NewsletterWidget.tsx',
        'ContactWidget.tsx',
        'index.ts',
        'ui/button.tsx',
        'ui/input.tsx',
        'ui/textarea.tsx',
        'ui/dialog.tsx',
        'ui/checkbox.tsx',
        'ui/radio-group.tsx'
      ]
    }
  };
}